'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$Query(action, days, user, page) {
  this.q5 = null;
  this.q6 = null;
  this.q8 = null;
  this.q7 = 0;
  this.q5 = action;
  this.q6 = days;
  this.q8 = user;
  this.q7 = page;
}
export { $c_Lpresto_AuditView$Query as $c_Lpresto_AuditView$Query };
$p = $c_Lpresto_AuditView$Query.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$Query;
/** @constructor */
function $h_Lpresto_AuditView$Query() {
}
export { $h_Lpresto_AuditView$Query as $h_Lpresto_AuditView$Query };
$h_Lpresto_AuditView$Query.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Query"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.q5));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.q6));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.q8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.q7);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 4);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AuditView$Query)) {
    if ((this.q7 === x$0.q7)) {
      var x = this.q5;
      var x$2 = x$0.q5;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.q6;
      var x$4 = x$0.q6;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.q8;
      var x$6 = x$0.q8;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "Query";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.q5;
      break;
    }
    case 1: {
      return this.q6;
      break;
    }
    case 2: {
      return this.q8;
      break;
    }
    case 3: {
      return this.q7;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_AuditView$Query(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hS)));
}
export { $isArrayOf_Lpresto_AuditView$Query as $isArrayOf_Lpresto_AuditView$Query };
var $d_Lpresto_AuditView$Query = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$Query, "presto.AuditView$Query", ({
  hS: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AuditView$Query as $d_Lpresto_AuditView$Query };
//# sourceMappingURL=presto.-Audit-View$-Query.js.map
